import Svg from '@app/components/svg';

const DocumentSearch = Svg(
  <>
    <g clip-path="url(#clip0_807_927)">
      <g filter="url(#filter0_d_807_927)">
        <path
          d="M139.621 74.444H43.8673C42.2167 74.444 40.8787 75.7821 40.8787 77.4326V205.775C40.8787 207.425 42.2167 208.763 43.8673 208.763H139.621C141.272 208.763 142.61 207.425 142.61 205.775V77.4326C142.61 75.7821 141.272 74.444 139.621 74.444Z"
          fill="white"
        />
        <path
          d="M129.755 122.606H55.4914C54.5447 122.606 53.7773 123.373 53.7773 124.32V148.112C53.7773 149.058 54.5447 149.826 55.4914 149.826H129.755C130.702 149.826 131.469 149.058 131.469 148.112V124.32C131.469 123.373 130.702 122.606 129.755 122.606Z"
          fill="white"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M92.6514 122.606V149.83"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M53.7773 131.668H131.473"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M53.7773 140.768H131.473"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M80.04 134.809H57.1792V137.68H80.04V134.809Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M87.8139 125.686H57.1792V128.557H87.8139V125.686Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M83.133 143.909H57.1792V146.781H83.133V143.909Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M115.934 125.686H96.3491V128.557H115.934V125.686Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M126.827 134.756H96.3491V137.628H126.827V134.756Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M119.21 143.909H96.3491V146.781H119.21V143.909Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M71 104H54V107H71V104Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
        />
        <path
          d="M131 104H74V107H131V104Z"
          fill="#D3E8F4"
        />
        <path
          d="M131.469 97.0263H53.7773V100.82H131.469V97.0263Z"
          fill="#D3E8F4"
        />
        <path
          d="M131.469 89.6874H53.7773V93.4809H131.469V89.6874Z"
          fill="#D3E8F4"
        />
        <path
          d="M102.048 110.016H53.7773V113.81H102.048V110.016Z"
          fill="#D3E8F4"
        />
        <path
          d="M131.469 180.635H53.7773V184.428H131.469V180.635Z"
          fill="#D3E8F4"
        />
        <path
          d="M131.469 174.14H53.7773V177.933H131.469V174.14Z"
          fill="#D3E8F4"
        />
        <path
          d="M131.469 159.375H53.7773V163.168H131.469V159.375Z"
          fill="#D3E8F4"
        />
        <path
          d="M131.469 166.805H53.7773V170.598H131.469V166.805Z"
          fill="#D3E8F4"
        />
        <path
          d="M73.1144 187.129H53.7773V190.923H73.1144V187.129Z"
          fill="#D3E8F4"
        />
      </g>
      <g filter="url(#filter1_d_807_927)">
        <path
          d="M189.737 47.3304L94.5309 57.5603C92.8897 57.7367 91.7023 59.21 91.8786 60.8512L105.59 188.459C105.766 190.1 107.24 191.287 108.881 191.111L204.087 180.881C205.728 180.705 206.916 179.231 206.739 177.59L193.028 49.9826C192.852 48.3415 191.378 47.154 189.737 47.3304Z"
          fill="white"
        />
        <path
          d="M181.456 63.5513L107.825 71.463C106.827 71.5703 106.104 72.4668 106.211 73.4653L109.487 103.955C109.595 104.954 110.491 105.676 111.49 105.569L185.121 97.657C186.119 97.5497 186.842 96.6533 186.735 95.6547L183.458 65.1651C183.351 64.1665 182.455 63.444 181.456 63.5513Z"
          fill="#D3E8F4"
        />
        <path
          d="M162.809 73.4568L128.055 77.1911C127.331 77.2689 126.807 77.9187 126.885 78.6426L128.734 95.8446C128.811 96.5685 129.461 97.0922 130.185 97.0144L164.939 93.28C165.663 93.2022 166.187 92.5524 166.109 91.8286L164.261 74.6265C164.183 73.9027 163.533 73.379 162.809 73.4568Z"
          fill="#D3E8F4"
          stroke="white"
          stroke-width="2.06"
          stroke-miterlimit="10"
        />
        <path
          d="M131.263 94.7459L163.495 91.2825C163.928 91.236 164.088 90.6937 163.753 90.4192L152.391 81.1085C151.878 80.6868 151.117 80.7686 150.704 81.2898L144.775 88.77C144.431 89.2006 143.839 89.3431 143.336 89.1083L139.208 87.1717C138.77 86.965 138.25 87.0472 137.891 87.3788L130.875 93.9038C130.528 94.2254 130.791 94.7966 131.258 94.7464L131.263 94.7459Z"
          fill="white"
        />
        <path
          d="M133.541 82.0271C134.429 81.9316 135.072 81.1338 134.977 80.2452C134.881 79.3565 134.084 78.7136 133.195 78.809C132.306 78.9045 131.663 79.7023 131.759 80.591C131.854 81.4796 132.652 82.1226 133.541 82.0271Z"
          fill="white"
        />
        <path
          d="M189.724 139.524L115.886 147.458C114.944 147.559 114.263 148.404 114.365 149.346L116.906 173.001C117.007 173.942 117.852 174.623 118.794 174.522L192.632 166.588C193.574 166.487 194.255 165.642 194.153 164.701L191.612 141.045C191.511 140.104 190.666 139.423 189.724 139.524Z"
          fill="white"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M152.833 143.488L155.741 170.552"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M115.149 156.647L192.396 148.347"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M116.122 165.7L193.369 157.4"
          stroke="#D3E8F4"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M148.425 156.235L118.867 159.411L119.174 162.265L148.732 159.089L148.425 156.235Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M137.807 148.2L117.893 150.34L118.2 153.195L138.114 151.055L137.807 148.2Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M134.727 166.86L119.84 168.459L120.146 171.314L135.033 169.714L134.727 166.86Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M185.359 143.091L156.834 146.156L157.141 149.011L185.666 145.946L185.359 143.091Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M174.548 153.375L157.804 155.174L158.11 158.029L174.855 156.23L174.548 153.375Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M176.894 162.329L158.781 164.275L159.088 167.13L177.201 165.184L176.894 162.329Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.87"
          stroke-miterlimit="10"
        />
        <path
          d="M189.368 120.162L112.121 128.463L112.526 132.234L189.773 123.934L189.368 120.162Z"
          fill="#D3E8F4"
        />
        <path
          d="M188.674 113.705L111.427 122.005L111.832 125.777L189.079 117.476L188.674 113.705Z"
          fill="#D3E8F4"
        />
        <path
          d="M187.89 106.412L110.643 114.712L111.049 118.484L188.296 110.184L187.89 106.412Z"
          fill="#D3E8F4"
        />
        <path
          d="M160.809 129.763L112.815 134.92L113.22 138.692L161.214 133.535L160.809 129.763Z"
          fill="#D3E8F4"
        />
      </g>
      <path
        d="M202.27 74.6098L202.269 76.284L204.978 76.2831L203.065 78.196L204.249 79.3798L206.162 77.4669L206.161 80.1755L207.835 80.175L207.836 77.4664L209.748 79.3782L210.932 78.1937L209.02 76.2819L211.729 76.2811L211.729 74.607L209.021 74.6078L210.934 72.6949L209.75 71.5111L207.837 73.424L207.838 70.7154L206.164 70.7159L206.163 73.4245L204.251 71.5127L203.067 72.6972L204.978 74.609L202.27 74.6098ZM205.006 74.6226L206.17 73.4585L207.817 73.458L208.98 74.6214L208.979 76.2683L207.815 77.4324L206.168 77.4329L205.005 76.2695L205.006 74.6226Z"
        fill="#99B0B7"
      />
    </g>
    <path
      d="M188.038 69.0038C197.835 69.0038 205.777 61.0616 205.777 51.2645C205.777 41.4674 197.835 33.5252 188.038 33.5252C178.242 33.5252 170.3 41.4674 170.3 51.2645C170.3 61.0616 178.242 69.0038 188.038 69.0038Z"
      fill="#F2F6F8"
    />
    <path
      d="M159.015 29.7501L157.831 30.9347L159.77 32.8736L160.954 31.6891L159.015 29.7501Z"
      fill="#99B0B7"
    />
    <path
      d="M163.764 34.4989L162.579 35.6834L164.518 37.6224L165.703 36.4379L163.764 34.4989Z"
      fill="#99B0B7"
    />
    <path
      d="M164.514 29.7484L162.574 31.6885L163.758 32.8723L165.698 30.9322L164.514 29.7484Z"
      fill="#99B0B7"
    />
    <path
      d="M159.762 34.5001L157.822 36.4403L159.006 37.6241L160.946 35.6839L159.762 34.5001Z"
      fill="#99B0B7"
    />
    <path
      d="M221.058 50.0312L219.867 51.2225L221.058 52.4131L222.249 51.2218L221.058 50.0312Z"
      fill="#99B0B7"
    />
    <path
      d="M215.567 50.0399L214.375 51.2312L215.566 52.4218L216.757 51.2305L215.567 50.0399Z"
      fill="#99B0B7"
    />
    <path
      d="M221.067 44.5394L219.876 45.7307L221.067 46.9213L222.258 45.73L221.067 44.5394Z"
      fill="#99B0B7"
    />
    <path
      d="M215.568 44.5411L214.377 45.7324L215.568 46.923L216.759 45.7317L215.568 44.5411Z"
      fill="#99B0B7"
    />
    <path
      d="M196.836 60.062L192.177 55.4023M179.435 49.9612C179.435 51.8974 180.204 53.7542 181.573 55.1233C182.942 56.4924 184.799 57.2615 186.735 57.2615C188.671 57.2615 190.528 56.4924 191.897 55.1233C193.266 53.7542 194.036 51.8974 194.036 49.9612C194.036 48.025 193.266 46.1681 191.897 44.7991C190.528 43.43 188.671 42.6608 186.735 42.6608C184.799 42.6608 182.942 43.43 181.573 44.7991C180.204 46.1681 179.435 48.025 179.435 49.9612Z"
      stroke="#99B0B7"
      stroke-width="2.32"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_807_927"
        x="16.8787"
        y="50.444"
        width="149.732"
        height="182.319"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_807_927"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_807_927"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_807_927"
        x="67.8613"
        y="23.313"
        width="162.896"
        height="191.815"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_807_927"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_807_927"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_807_927">
        <rect
          width="197.068"
          height="187.932"
          fill="white"
          transform="translate(25 36.5704)"
        />
      </clipPath>
    </defs>
  </>,
  {
    viewBox: '25 0 200 211',
    fill: 'none',
  },
);

DocumentSearch.displayName = 'DocumentSearch';

export default DocumentSearch;
